<template>
  <div class="col-12 p-2 d-flex align-items-center mt-4">
    <div class="w-100 pt-0 ">
      <div class="title-divider-left"></div>
    </div>
    <div class="col-auto title-content py-1 text-center mx-3">
      <div>
        <span>{{ title }}</span>
      </div>
    </div>
    <div class="w-100 pt-0 ">
      <div class="title-divider-right w-100"></div>
    </div>
  </div>
</template> 

<script>
export default {
  name: "CustomTitleDivider",
  props: {
    title: {
      type: String,
      default: () => ""
    }
  }
};
</script>

<style scoped>
.title-divider-left {
  border: 1px solid #b5c3bc;
  opacity: 1;
  margin-left: -7px;
}

.title-divider-right {
  border: 1px solid #b5c3bc;
  opacity: 1;
  margin-left: 7px;
}

.title-content {
  background: #3f5b60 0% 0% no-repeat padding-box;
  border-radius: 21px;
  opacity: 1;
  text-align: center;
  font: Bold 17px/23px Lato;
  letter-spacing: 0;
  color: #ffffff;
}
</style>